import React from 'react'
import { Input, Label } from 'reactstrap'

const ArchiveFilter = ({ value, change, disabled }) => <div className='mb-3' style={ { maxWidth: 260 } }>
  <Label for='settings-archive-status'>Status data</Label>
  <Input id='settings-archive-status' aria-label='Status data arsip' type='select' value={ value ? 'true' : 'false' } disabled={ disabled } onChange={ (event) => change(event.target.value === 'true') }><option value='false'>Data utama</option><option value='true'>Arsip (soft-deleted)</option></Input>
  <small className='text-muted'>Arsip menyimpan data dan relasi; gunakan Restore untuk menampilkan kembali.</small>
</div>

export default ArchiveFilter
